import {  useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import PageURL from "../../../constants/PageURL";

/* ##### Protected Route to Protect user Routes  ##### */

const ProtectedAdminRoute = () => {
  const {  user } = useSelector((state) => state.user);



  if (user?.userLevel===1) {
    return <Outlet />;
  }else return <Navigate to={PageURL.COUNTRYDEFAULT}/>
  
};

export default ProtectedAdminRoute;
